import React from 'react';
import './Intro.scss';
import navIcon from '../../assets/popup/nav-icon.png';
import navIconM from '../../assets/popup/nav-icon-mobile.png';
import zoomIcon from '../../assets/popup/zoom-icon.png';
import compareIcon from '../../assets/popup/compare-icon.png';
import resetIcon from '../../assets/popup/reset-icon.png';
import resetIconM from '../../assets/popup/reset-icon-mobile.png';
import mouse from '../../assets/popup/newmouse.svg';

function HowTo() {
  return (
    <div className="howTo">
      <p className="howTo__title howTo__title--intro">How to use the map</p>

      <div className="howTo__icons howTo__icons--intro">
        <div className="howTo__icons--row1">
          <div className="howTo__icons__icon">
            <img src={navIcon} className="howTo__icons__icon-icon desktop-only" alt="" />
            <img src={navIconM} className="howTo__icons__icon-icon mobile-only" alt="" />
            <p className="howTo__icons__icon-text desktop-only">
              Use the top tabs to navigate different data sets
            </p>
            <p className="howTo__icons__icon-text mobile-only">
              Swipe the top tabs to navigate different data sets
            </p>
          </div>

          <div className="howTo__icons__icon">
            <img src={resetIcon} className="howTo__icons__icon-icon desktop-only" alt="" />
            <img src={resetIconM} className="howTo__icons__icon-icon mobile-only" alt="" />
            <p className="howTo__icons__icon-text desktop-only">
              Click to <span className="howTo__icons__icon-text--bold">reset</span> to national map
              view
            </p>
            <p className="howTo__icons__icon-text mobile-only">
              Tap to <span className="howTo__icons__icon-text--bold">reset</span> to national map
              view
            </p>
          </div>
          <div className="howTo__icons__icon">
            <img src={compareIcon} className="howTo__icons__icon-icon" alt="" />
            <p className="howTo__icons__icon-text">
              <span className="howTo__icons__icon-text--bold">+ Add</span> metro zones to compare
            </p>
          </div>
        </div>
        <div className="howTo__icons--row2">
          <div className="howTo__icons__icon--row">
            <img src={zoomIcon} className="howTo__icons__icon-icon click" alt="" />
            <p className="howTo__icons__icon-text howTo__icons__icon-text--row">
              <span className="howTo__icons__icon-text--bold">Click</span> metro zones for more
              details
            </p>
          </div>
          <div className="howTo__icons__icon--row">
            <img src={mouse} className="howTo__icons__icon-icon mouse" alt="" />
            <p className="howTo__icons__icon-text howTo__icons__icon-text--row ">
              Use mouse to <span className="howTo__icons__icon-text--bold">•click and drag</span> to
              explore
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowTo;
